import { formatDDMMYYYY } from "../pages/Documents/forms/Html/LeagleDocuments/forms/commonfunctions";
import BASE from "../config";
import url from "../services/url";
import { STATE_AND_CITIES } from "../utils/StateAndCities";
import { capitalizeEachWord } from "../utils/commonFunctions";

const useLegalPrifilledData = () => {
  const filledData = (
    html,
    values,
    application,
    _photo,
    _sign,
    documentType,
    logoBase
  ) => {

    if (logoBase) {
      const logo = html.getElementById("logo");
      logo.src = logoBase
    }

    const signature = html.querySelectorAll(".signature");
    let candidateState = "";
    if (application?.workLocation) {
      for (let state in STATE_AND_CITIES) {
        if (
          STATE_AND_CITIES[state].some((city) => {
            return city?.city === application?.workLocation;
          })
        ) {
          candidateState = state;
          break;
        }
      }
    }

    if (signature) {
      for (let i = 0; i < signature.length; i++) {
        signature[i].src =
          documentType === "S3" && BASE.storageType
            ? _sign
            : url() + application?.candidateSignature[0]?.path;
      }
    }

    const date = html.querySelectorAll(".date_of_joining");
    if (date) {
      for (let i = 0; i < date.length; i++) {
        date[i].innerText = application?.DateOfJoining
          ? formatDDMMYYYY(new Date(application?.DateOfJoining))
          : "";
      }
    }

    if (html.getElementById("photo") !== null) {
      html.getElementById("photo").src =
        documentType === "S3" && BASE.storageType
          ? _photo
          : url() + (application?.documetImage?.[0]?.path || application?.candidatePhoto?.[0]?.path);
    }

    if (
      html.getElementById("married") !== null ||
      html.getElementById("unmarried") !== null ||
      html.getElementById("widow") !== null
    ) {
      if (values?.marital_status) {
        const maritalEl =
          html.getElementById(values.marital_status.toLowerCase()) ||
          html.getElementById(values.marital_status);
        if (maritalEl) {
          maritalEl.style.display = "flex";
        }
      }
    }

    if (
      html.getElementById("male") !== null ||
      html.getElementById("female") !== null
    ) {
      values?.sex && (html.getElementById(values?.sex).style.display = "flex");
    }

    if (html.getElementById("name") !== null) {
      values?.name && (html.getElementById("name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("father_name") !== null) {
      values?.father_name &&
        (html.getElementById("father_name").innerText = capitalizeEachWord(values?.father_name));
    }

    if (html.getElementById("dob_DD") !== null) {
      values?.dob &&
        (html.getElementById("dob_DD").innerText = values?.dob?.split("-")[2]);
    }

    if (html.getElementById("dob_MM") !== null) {
      values?.dob &&
        (html.getElementById("dob_MM").innerText = values?.dob?.split("-")[1]);
    }

    if (html.getElementById("dob_YY") !== null) {
      values?.dob &&
        (html.getElementById("dob_YY").innerText = values?.dob?.split("-")[0]);
    }

    if (html.getElementById("doa_DD") !== null) {
      html.getElementById("doa_DD").innerText = application?.DateOfJoining
        ? new Date(application?.DateOfJoining)?.getDate()
        : "";
    }

    if (html.getElementById("doa_MM") !== null) {
      html.getElementById("doa_MM").innerText = application?.DateOfJoining
        ? new Date(application?.DateOfJoining)?.getMonth() + 1
        : "";
    }

    if (html.getElementById("doa_YY") !== null) {
      html.getElementById("doa_YY").innerText = application?.DateOfJoining
        ? new Date(application?.DateOfJoining)?.getFullYear()
        : "";
    }

    if (html.getElementById("present_address") !== null) {
      values?.present_address &&
        (html.getElementById("present_address").innerText =
          values?.present_address?.replace(/\n/g, " ")?.trim());
    }
    if (html.getElementById("permanent_address") !== null) {
      values?.permanent_address &&
        (html.getElementById("permanent_address").innerText =
          values?.permanent_address?.replace(/\n/g, " ")?.trim());
    }
    if (html.getElementById("permanent_email") !== null) {
      values?.permanent_email &&
        (html.getElementById("permanent_email").innerText =
          values?.permanent_email);
    }

    if (html.getElementById("present_email") !== null) {
      values?.present_email &&
        (html.getElementById("present_email").innerText =
          values?.present_email);
    }

    if (html.getElementById("name_of_nominee") !== null) {
      values?.name_of_nominee &&
        (html.getElementById("name_of_nominee").innerText =
          capitalizeEachWord(values?.name_of_nominee));
    }

    if (html.getElementById("relationship_with_insured_person") !== null) {
      values?.relationship_with_insured_person &&
        (html.getElementById("relationship_with_insured_person").innerText =
          values?.relationship_with_insured_person);
    }

    if (html.getElementById("address_of_the_nominee") !== null) {
      values?.address_of_the_nominee &&
        (html.getElementById("address_of_the_nominee").innerText =
          values?.address_of_the_nominee?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("validity_date") !== null) {
      values?.validity_date &&
        (html.getElementById("validity_date").innerText =
          values?.validity_date);
    }

    if (html.getElementById("present_pin") !== null) {
      if (values?.present_pin) {
        let presentPin = values?.present_pin?.split("");
        for (let i = 0; i < 6; i++) {
          presentPin[i] &&
            (html.getElementById(`present_pin_${i + 1}`).innerText =
              presentPin[i]);
        }
      }
    }

    if (html.getElementById("permanent_pin") !== null) {
      if (values?.permanent_pin) {
        let permanentPin = values?.permanent_pin?.split("");
        for (let i = 0; i < 6; i++) {
          permanentPin[i] &&
            (html.getElementById(`permanent_pin_${i + 1}`).innerText =
              permanentPin[i]);
        }
      }
    }

    if (html.getElementById("ins_no") !== null) {
      values?.ins_no &&
        (html.getElementById("ins_no").innerText = values?.ins_no);
    }

    if (html.getElementById("ins_no") !== null) {
      values?.insauranceNumber &&
        (html.getElementById("ins_no").innerText = values?.insauranceNumber);
    }

    if (html.getElementById("dispensary") !== null) {
      values?.dispensary &&
        (html.getElementById("dispensary").innerText = values?.dispensary);
    }

    if (html.getElementById("previous_ins_no") !== null) {
      values?.prevInsauranceNumber &&
        (html.getElementById("previous_ins_no").innerText =
          values?.prevInsauranceNumber);
    }

    if (html.getElementById("esi_relation_check_father") !== null) {
      if (values?.relation === "father") {
        html.getElementById("esi_relation_check_father").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("esi_relation_check_husband") !== null) {
      if (values?.relation === "husband") {
        html.getElementById("esi_relation_check_husband").style.display =
          "inline-block";
      }
    }

    //Form 11

    if (values?.withdrawn_accumulations === "yes") {
      if (html.getElementById("form11_withdrawn_accumulations_yes") !== null) {
        values?.withdrawn_accumulations &&
          (html.getElementById(
            "form11_withdrawn_accumulations_yes"
          ).style.display = "inline-block");
      }
    } else {
      if (html.getElementById("form11_withdrawn_accumulations_no") !== null) {
        values?.withdrawn_accumulations &&
          (html.getElementById(
            "form11_withdrawn_accumulations_no"
          ).style.display = "inline-block");
      }
    }

    if (values?.provident_fund_scheme === "yes") {
      if (html.getElementById("form11_provident_fund_scheme_yes") !== null) {
        values?.provident_fund_scheme &&
          (html.getElementById(
            "form11_provident_fund_scheme_yes"
          ).style.display = "inline-block");
      }
    } else {
      if (html.getElementById("form11_provident_fund_scheme_no") !== null) {
        values?.provident_fund_scheme &&
          (html.getElementById(
            "form11_provident_fund_scheme_no"
          ).style.display = "inline-block");
      }
    }

    if (values?.pension_scheme === "yes") {
      if (html.getElementById("form11_pension_scheme_yes") !== null) {
        values?.pension_scheme &&
          (html.getElementById("form11_pension_scheme_yes").style.display =
            "inline-block");
      }
    } else {
      if (html.getElementById("form11_pension_scheme_no") !== null) {
        values?.pension_scheme &&
          (html.getElementById("form11_pension_scheme_no").style.display =
            "inline-block");
      }
    }

    if (
      values?.provident_fund_scheme === "yes" ||
      values?.pension_scheme === "yes"
    ) {
      if (html.getElementById("pension_scheme_nominee_form11") !== null) {
        if (values?.pensionnominees) {
          if (
            html.getElementById("pension_scheme_nominee_form11").rows.length > 1
          ) {
            html.getElementById("pension_scheme_nominee_form11").deleteRow(1);
          }
          for (let i = 0; i < values?.pensionnominees.length; i++) {
            const tr = document.createElement("tr");
            const td = document.createElement("td");
            const span = document.createElement("span");
            span.style.textAlign = "center";
            span.style.display = "block";
            td.style.height = "40px";
            span.innerText = values?.pensionnominees[
              i
            ]?.name_and_address_of_trust
              ?.replace(/\n/g, " ")
              ?.trim();
            td.appendChild(span);
            tr.appendChild(td);

            const td1 = document.createElement("td");
            const span1 = document.createElement("span");
            span1.style.textAlign = "center";
            span1.style.display = "block";
            td1.style.height = "40px";
            span1.innerText =
              values?.pensionnominees[i].universal_account_number;
            td1.appendChild(span1);
            tr.appendChild(td1);

            const td2 = document.createElement("td");
            const span2 = document.createElement("span");
            span2.style.textAlign = "center";
            span2.style.display = "block";
            td2.style.height = "40px";
            span2.innerText = values?.pensionnominees[i].eps_account_number;
            td2.appendChild(span2);
            tr.appendChild(td2);

            const td3 = document.createElement("td");
            const span3 = document.createElement("span");
            span3.style.textAlign = "center";
            span3.style.display = "block";
            td3.style.height = "40px";
            span3.innerText = values?.pensionnominees[i].date_of_joining
              ? formatDDMMYYYY(
                new Date(values?.pensionnominees[i].date_of_joining)
              )
              : "";
            td3.appendChild(span3);
            tr.appendChild(td3);

            const td4 = document.createElement("td");
            const span4 = document.createElement("span");
            span4.style.textAlign = "center";
            span4.style.display = "block";
            td4.style.height = "40px";
            span4.innerText = values?.pensionnominees[i].date_of_exit
              ? formatDDMMYYYY(
                new Date(values?.pensionnominees[i].date_of_exit)
              )
              : "";
            td4.appendChild(span4);
            tr.appendChild(td4);

            const td5 = document.createElement("td");
            const span5 = document.createElement("span");
            span5.style.textAlign = "center";
            span5.style.display = "block";
            td5.style.height = "40px";
            span5.innerText =
              values?.pensionnominees[i].scheme_certificate || "";
            td5.appendChild(span5);
            tr.appendChild(td5);

            const td7 = document.createElement("td");
            const span7 = document.createElement("span");
            span7.style.textAlign = "center";
            span7.style.display = "block";
            td7.style.height = "40px";
            span7.innerText = values?.pensionnominees[i].ncp_days || "";
            td7.appendChild(span7);
            tr.appendChild(td7);

            html
              .getElementById("pension_scheme_nominee_form11")
              .appendChild(tr);
          }
        }
      }
      if (html.getElementById("nominee_form11") !== null) {
        if (values?.nominees) {
          if (html.getElementById("nominee_form11").rows.length > 1) {
            html.getElementById("nominee_form11").deleteRow(1);
          }
          for (let i = 0; i < values?.nominees.length; i++) {
            const tr = document.createElement("tr");
            const td = document.createElement("td");
            const span = document.createElement("span");
            span.style.textAlign = "center";
            span.style.display = "block";
            td.style.height = "40px";
            span.innerText = values?.nominees[i].name_of_establishment;
            td.appendChild(span);
            tr.appendChild(td);

            const td1 = document.createElement("td");
            const span1 = document.createElement("span");
            span1.style.textAlign = "center";
            span1.style.display = "block";
            td1.style.height = "40px";
            span1.innerText = values?.nominees[i].universal_account_number;
            td1.appendChild(span1);
            tr.appendChild(td1);

            const td2 = document.createElement("td");
            const span2 = document.createElement("span");
            span2.style.textAlign = "center";
            span2.style.display = "block";
            td2.style.height = "40px";
            td2.style.wordBreak = "break-all";
            span2.innerText = values?.nominees[i].pf_account_number;
            td2.appendChild(span2);
            tr.appendChild(td2);

            const td3 = document.createElement("td");
            const span3 = document.createElement("span");
            span3.style.textAlign = "center";
            span3.style.display = "block";
            td3.style.height = "40px";
            span3.innerText = values?.nominees[i].date_of_joining
              ? formatDDMMYYYY(new Date(values?.nominees[i].date_of_joining))
              : "";
            td3.appendChild(span3);
            tr.appendChild(td3);

            const td4 = document.createElement("td");
            const span4 = document.createElement("span");
            span4.style.textAlign = "center";
            span4.style.display = "block";
            td4.style.height = "40px";
            span4.innerText = values?.nominees[i].date_of_exit
              ? formatDDMMYYYY(new Date(values?.nominees[i].date_of_exit))
              : "";
            td4.appendChild(span4);
            tr.appendChild(td4);

            const td5 = document.createElement("td");
            const span5 = document.createElement("span");
            span5.style.textAlign = "center";
            span5.style.display = "block";
            td5.style.height = "40px";
            span5.innerText = values?.nominees[i].scheme_certificate || "";
            td5.appendChild(span5);
            tr.appendChild(td5);

            const td6 = document.createElement("td");
            const span6 = document.createElement("span");
            span6.style.textAlign = "center";
            span6.style.display = "block";
            td6.style.height = "40px";
            span6.innerText = values?.nominees[i].ppo_number || "";
            td6.appendChild(span6);
            tr.appendChild(td6);

            const td7 = document.createElement("td");
            const span7 = document.createElement("span");
            span7.style.textAlign = "center";
            span7.style.display = "block";
            td7.style.height = "40px";
            span7.innerText = values?.nominees[i].ncp_days || "";
            td7.appendChild(span7);
            tr.appendChild(td7);

            html.getElementById("nominee_form11").appendChild(tr);
          }
        }
      }
    }

    if (html.getElementById("form11_name") !== null) {
      values?.name &&
        (html.getElementById("form11_name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("form11_dob") !== null) {
      values?.dob &&
        (html.getElementById("form11_dob").innerText = formatDDMMYYYY(
          new Date(values?.dob)
        ));
    }

    if (html.getElementById("form11_gender") !== null) {
      values?.sex &&
        (html.getElementById("form11_gender").innerText = values?.sex);
    }

    if (html.getElementById("form11_merital_status") !== null) {
      values?.marital_status &&
        (html.getElementById("form11_merital_status").innerText =
          values?.marital_status);
    }

    if (html.getElementById("form11_mobile_number") !== null) {
      values?.mobile_number &&
        (html.getElementById("form11_mobile_number").innerText =
          values?.mobile_number);
    }

    if (html.getElementById("form11_email") !== null) {
      values?.email &&
        (html.getElementById("form11_email").innerText = values?.email);
    }

    if (html.getElementById("form11_aadhar_number") !== null) {
      values?.aadhar_number &&
        (html.getElementById("form11_aadhar_number").innerText =
          values?.aadhar_number);
    }

    if (html.getElementById("form11_pan_number") !== null) {
      values?.pan_number &&
        (html.getElementById("form11_pan_number").innerText =
          values?.pan_number);
    }

    if (html.getElementById("form11_date") !== null) {
      values?.date &&
        (html.getElementById("form11_date").innerText = formatDDMMYYYY(
          new Date(values?.date)
        ));
    }

    if (html.getElementById("form11_place") !== null) {
      application?.workLocation &&
        (html.getElementById("form11_place").innerText =
          application?.workLocation);
    }

    if (html.getElementById("form11_banck_aac_number") !== null) {
      values?.accountNumber &&
        (html.getElementById("form11_banck_aac_number").innerText =
          values?.accountNumber);
    }

    if (html.getElementById("form11_ifc_code") !== null) {
      values?.ifcCode &&
        (html.getElementById("form11_ifc_code").innerText = values?.ifcCode);
    }

    if (html.getElementById("form11_father_spouse_name") !== null) {
      if (values?.fatherOrSpouse) {
        html.getElementById("form11_father_spouse_name").innerText =
          values?.father_name;
      } else {
        html.getElementById("form11_father_spouse_name").innerText =
          values?.spouse_name;
      }
    }

    if (html.getElementById("form11_father_name_check") !== null) {
      if (values?.fatherOrSpouse) {
        html.getElementById("form11_father_name_check").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("form11_spouse_name_check") !== null) {
      if (values?.fatherOrSpouse === false) {
        html.getElementById("form11_spouse_name_check").style.display =
          "inline-block";
      }
    }

    //Wages Form

    if (html.getElementById("wages_relation_check_father") !== null) {
      if (values?.relation === "father") {
        html.getElementById("wages_relation_check_father").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("wages_relation_check_husband") !== null) {
      if (values?.relation === "husband") {
        html.getElementById("wages_relation_check_husband").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("wgaes_name") !== null) {
      values?.name &&
        (html.getElementById("wgaes_name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("wages_father_name") !== null) {
      values?.father_name &&
        (html.getElementById("wages_father_name").innerText =
          values?.father_name);
    }

    if (html.getElementById("wages_dob") !== null) {
      values?.dob &&
        (html.getElementById("wages_dob").innerText = formatDDMMYYYY(
          new Date(values?.dob)
        ));
    }

    if (html.getElementById("wages_sex") !== null) {
      values?.sex && (html.getElementById("wages_sex").innerText = values?.sex);
    }

    if (html.getElementById("wages_marital_status") !== null) {
      values?.marital_status &&
        (html.getElementById("wages_marital_status").innerText =
          values?.marital_status);
    }

    if (html.getElementById("wages_permanent_address") !== null) {
      values?.permanent_address &&
        (html.getElementById("wages_permanent_address").innerText =
          values?.permanent_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("wages_temporary_address") !== null) {
      values?.temporary_address &&
        (html.getElementById("wages_temporary_address").innerText =
          values?.temporary_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("wages_candidate") !== null) {
      application?.name &&
        (html.getElementById("wages_candidate").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("wages_place") !== null) {
      application?.workLocation &&
        (html.getElementById("wages_place").innerText =
          application?.workLocation);
    }

    if (html.getElementById("nominee") !== null) {
      if (values?.nominees) {
        if (html.getElementById("nominee").rows.length > 2) {
          html.getElementById("nominee").deleteRow(2);
        }
        for (let i = 0; i < values?.nominees.length; i++) {
          const tr = document.createElement("tr");
          const td = document.createElement("td");
          const span = document.createElement("span");
          span.style.textAlign = "center";
          span.style.display = "block";
          td.style.height = "40px";
          span.innerText = values?.nominees[i].name_of_nominee;
          td.appendChild(span);
          tr.appendChild(td);

          const td1 = document.createElement("td");
          const span1 = document.createElement("span");
          span1.style.textAlign = "center";
          span1.style.display = "block";
          td1.style.height = "40px";
          span1.innerText = values?.nominees[i].address
            ?.replace(/\n/g, " ")
            ?.trim();
          td1.appendChild(span1);
          tr.appendChild(td1);

          const td2 = document.createElement("td");
          const span2 = document.createElement("span");
          span2.style.textAlign = "center";
          span2.style.display = "block";
          td2.style.height = "40px";
          span2.innerText = values?.nominees[i].nominee_relationship;
          td2.appendChild(span2);
          tr.appendChild(td2);

          const td3 = document.createElement("td");
          const span3 = document.createElement("span");
          span3.style.textAlign = "center";
          span3.style.display = "block";
          td3.style.height = "40px";
          span3.innerText = formatDDMMYYYY(
            new Date(values?.nominees[i].date_of_birth)
          );
          td3.appendChild(span3);
          tr.appendChild(td3);

          const td4 = document.createElement("td");
          const span4 = document.createElement("span");
          span4.style.textAlign = "center";
          span4.style.display = "block";
          td4.style.height = "40px";
          span4.innerText = `${values?.nominees[i].total_amount}%`;
          td4.appendChild(span4);
          tr.appendChild(td4);

          const td5 = document.createElement("td");
          const span5 = document.createElement("span");
          span5.style.textAlign = "center";
          span5.style.display = "block";
          td5.style.height = "40px";
          span5.innerText =
            values?.nominees[i].nominee_guardian_name_address
              ?.replace(/\n/g, " ")
              ?.trim() || "";
          td5.appendChild(span5);
          tr.appendChild(td5);

          html.getElementById("nominee").appendChild(tr);
        }
      }
    }

    //gratuity form

    if (html.getElementById("nominee_gratuity") !== null) {
      if (values?.nominees) {
        if (html.getElementById("nominee_gratuity").rows.length > 2) {
          html.getElementById("nominee_gratuity").deleteRow(2);
        }
        for (let i = 0; i < values?.nominees.length; i++) {
          const tr = document.createElement("tr");

          const tdS = document.createElement("td");
          const spanS = document.createElement("span");
          spanS.style.textAlign = "center";
          spanS.style.display = "block";
          tdS.style.borderRight = "none";
          tdS.style.height = "40px";
          spanS.innerText = `${i + 1}.`;
          tdS.appendChild(spanS);
          tr.appendChild(tdS);

          const td = document.createElement("td");
          const span = document.createElement("span");
          span.style.textAlign = "center";
          span.style.display = "block";
          td.style.borderLeft = "none";
          td.style.height = "40px";
          span.innerText = `${values?.nominees[i].name_of_nominee}`;
          td.appendChild(span);
          tr.appendChild(td);

          const td1 = document.createElement("td");
          const span1 = document.createElement("span");
          span1.style.textAlign = "center";
          span1.style.display = "block";
          td1.style.height = "40px";
          span1.innerText = values?.nominees[i].relationship;
          td1.appendChild(span1);
          tr.appendChild(td1);

          const td2 = document.createElement("td");
          const span2 = document.createElement("span");
          span2.style.textAlign = "center";
          span2.style.display = "block";
          td2.style.height = "40px";
          span2.innerText = values?.nominees[i].age_of_nominee;
          td2.appendChild(span2);
          tr.appendChild(td2);

          const td3 = document.createElement("td");
          const span3 = document.createElement("span");
          span3.style.textAlign = "center";
          span3.style.display = "block";
          td3.style.height = "40px";
          span3.innerText = `${values?.nominees[i].total_amount}%`;
          td3.appendChild(span3);
          tr.appendChild(td3);
          html.getElementById("nominee_gratuity").appendChild(tr);
        }
      }
    }

    if (html.getElementById("gratuity_name") !== null) {
      values?.name_of_employee &&
        (html.getElementById("gratuity_name").innerText =
          values?.name_of_employee);
    }

    if (html.getElementById("gratuity_place") !== null) {
      application?.workLocation &&
        (html.getElementById("gratuity_place").innerText =
          application?.workLocation);
    }

    if (html.getElementById("gratuity_sex") !== null) {
      values?.sex &&
        (html.getElementById("gratuity_sex").innerText = values?.sex);
    }

    if (html.getElementById("gratuity_religion") !== null) {
      values?.religion &&
        (html.getElementById("gratuity_religion").innerText = values?.religion);
    }

    if (html.getElementById("gratuity_marital_status") !== null) {
      values?.marital_status &&
        (html.getElementById("gratuity_marital_status").innerText =
          values?.marital_status);
    }

    if (html.getElementById("gratuity_department_branch_section") !== null) {
      values?.department_branch_section &&
        (html.getElementById("gratuity_department_branch_section").innerText =
          values?.department_branch_section);
    }

    if (html.getElementById("gratuity_date_of_appointment") !== null) {
      html.getElementById("gratuity_date_of_appointment").innerText =
        formatDDMMYYYY(new Date(application?.DateOfJoining));
    }

    if (html.getElementById("gratuity_permanent_address") !== null) {
      values?.permanent_address &&
        (html.getElementById("gratuity_permanent_address").innerText =
          values?.permanent_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("gratuity_permanent_address") !== null) {
      values?.permanent_address &&
        (html.getElementById("gratuity_permanent_address").innerText =
          values?.permanent_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("gratuity_district") !== null) {
      application?.workLocation &&
        (html.getElementById("gratuity_district").innerText = application?.workLocation);
    }

    if (html.getElementById("gratuity_state") !== null) {
      candidateState &&
        (html.getElementById("gratuity_state").innerText = candidateState);
    }

    if (html.getElementById("gratuity_name_of_employee") !== null) {
      values?.name_of_employee &&
        (html.getElementById("gratuity_name_of_employee").innerText =
          values?.name_of_employee);
    }

    //Accidental Form

    if (html.getElementById("accident_name") !== null) {
      values?.name &&
        (html.getElementById("accident_name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("accident_residential_address") !== null) {
      values?.residential_address &&
        (html.getElementById("accident_residential_address").innerText =
          values?.residential_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("accident_office_address") !== null) {
      values?.office_address &&
        (html.getElementById("accident_office_address").innerText =
          values?.office_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("accident_dob") !== null) {
      values?.dob &&
        (html.getElementById("accident_dob").innerText = formatDDMMYYYY(
          new Date(values?.dob)
        ));
    }

    if (html.getElementById("accident_age") !== null) {
      values?.age &&
        (html.getElementById("accident_age").innerText = values?.age);
    }

    if (html.getElementById("accident_disability") !== null) {
      values?.disability &&
        (html.getElementById("accident_disability").innerText =
          values?.disability);
    }

    if (html.getElementById("accident_assignment_name") !== null) {
      values?.assignment_name &&
        (html.getElementById("accident_assignment_name").innerText =
          values?.assignment_name);
    }

    if (html.getElementById("accident_death_name") !== null) {
      values?.death_name &&
        (html.getElementById("accident_death_name").innerText =
          values?.death_name);
    }

    if (html.getElementById("accident_assignment_relation") !== null) {
      values?.assignment_relation &&
        (html.getElementById("accident_assignment_relation").innerText =
          values?.assignment_relation);
    }

    if (html.getElementById("accident_place") !== null) {
      application?.workLocation &&
        (html.getElementById("accident_place").innerText =
          application?.workLocation);
    }

    if (html.getElementById("location") !== null) {
      html.getElementById("location").innerText =
        application?.workLocation || "";
    }

    if (application?.DateOfJoining) {
      if (html.getElementById("accidental_month") !== null) {
        html.getElementById("accidental_month").innerText =
          new Date(application?.DateOfJoining).getMonth() + 1;
      }

      if (html.getElementById("accidental_day") !== null) {
        html.getElementById("accidental_day").innerText = new Date(
          application?.DateOfJoining
        ).getDate();
      }

      if (html.getElementById("accidental_year") !== null) {
        html.getElementById("accidental_year").innerText =
          new Date().getFullYear();
      }
    }

    //EPF Form

    if (html.getElementById("epf_name") !== null) {
      values?.name &&
        (html.getElementById("epf_name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("epf_relation_check_father") !== null) {
      if (values?.relation === "father") {
        html.getElementById("epf_relation_check_father").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("epf_relation_check_husband") !== null) {
      if (values?.relation === "husband") {
        html.getElementById("epf_relation_check_husband").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("epf_father_name") !== null) {
      values?.father_name &&
        (html.getElementById("epf_father_name").innerText =
          values?.father_name);
    }

    if (html.getElementById("epf_dob") !== null) {
      values?.dob &&
        (html.getElementById("epf_dob").innerText = formatDDMMYYYY(
          new Date(values?.dob)
        ));
    }

    if (html.getElementById("epf_sex") !== null) {
      values?.sex && (html.getElementById("epf_sex").innerText = values?.sex);
    }

    if (html.getElementById("epf_marital_status") !== null) {
      values?.marital_status &&
        (html.getElementById("epf_marital_status").innerText =
          values?.marital_status);
    }

    if (html.getElementById("epf_permanent_address") !== null) {
      values?.permanent_address &&
        (html.getElementById("epf_permanent_address").innerText =
          values?.permanent_address?.replace(/\n/g, " ")?.trim());
    }

    if (html.getElementById("epf_temporary_address") !== null) {
      values?.temporary_address &&
        (html.getElementById("epf_temporary_address").innerText =
          values?.temporary_address?.replace(/\n/g, " ")?.trim());
    }
    if (html.getElementById("epf_nominee") !== null) {
      if (values?.nominees) {
        if (html.getElementById("epf_nominee").rows.length > 2) {
          html.getElementById("epf_nominee").deleteRow(2);
        }
        for (let i = 0; i < values?.nominees.length; i++) {
          const tr = document.createElement("tr");

          const td1 = document.createElement("td");
          const span1 = document.createElement("span");
          span1.style.textAlign = "center";
          span1.style.display = "block";
          td1.style.height = "40px";
          span1.innerText = values?.nominees[i].name_and_address_of_nominee
            ?.replace(/\n/g, " ")
            ?.trim();
          td1.appendChild(span1);
          tr.appendChild(td1);

          const td2 = document.createElement("td");
          const span2 = document.createElement("span");
          span2.style.textAlign = "center";
          span2.style.display = "block";
          td2.style.height = "40px";
          span2.innerText = values?.nominees[i].nominee_relationship;
          td2.appendChild(span2);
          tr.appendChild(td2);

          const td3 = document.createElement("td");
          const span3 = document.createElement("span");
          span3.style.textAlign = "center";
          span3.style.display = "block";
          td3.style.height = "40px";
          span3.innerText = values?.nominees[i].date_of_birth
            ? formatDDMMYYYY(new Date(values?.nominees[i].date_of_birth))
            : "";
          td3.appendChild(span3);
          tr.appendChild(td3);

          const td4 = document.createElement("td");
          const span4 = document.createElement("span");
          span4.style.textAlign = "center";
          span4.style.display = "block";
          td4.style.height = "40px";
          span4.innerText = values?.nominees[i].total_amount
            ? `${values?.nominees[i].total_amount}%`
            : "";
          td4.appendChild(span4);
          tr.appendChild(td4);

          const td5 = document.createElement("td");
          const span5 = document.createElement("span");
          span5.style.textAlign = "center";
          span5.style.display = "block";
          td5.style.height = "40px";
          span5.innerText =
            values?.nominees[i].nominee_guardian_name_address
              ?.replace(/\n/g, " ")
              ?.trim() || "";
          td5.appendChild(span5);
          tr.appendChild(td5);

          html.getElementById("epf_nominee").appendChild(tr);
        }
      }
    }

    // Mediclaim Form

    if (html.getElementById("mediclaim_name") !== null) {
      values?.name &&
        (html.getElementById("mediclaim_name").innerText = capitalizeEachWord(values?.name));
    }

    if (html.getElementById("mediclaim_address") !== null) {
      values?.address &&
        (html.getElementById("mediclaim_address").innerText = values?.address
          ?.replace(/\n/g, " ")
          ?.trim());
    }

    if (html.getElementById("mediclaim_pin") !== null) {
      values?.pin &&
        (html.getElementById("mediclaim_pin").innerText = values?.pin);
    }

    if (html.getElementById("mediclaim_state") !== null) {
      candidateState &&
        (html.getElementById("mediclaim_state").innerText = candidateState);
    }

    if (html.getElementById("mediclaim_relationship") !== null) {
      values?.relationship &&
        (html.getElementById("mediclaim_relationship").innerText =
          values?.relationship);
    }

    if (html.getElementById("mediclaim_place") !== null) {
      application?.workLocation &&
        (html.getElementById("mediclaim_place").innerText =
          application?.workLocation);
    }

    if (html.getElementById("mediclaim_dob") !== null) {
      values?.dob &&
        (html.getElementById("mediclaim_dob").innerText = formatDDMMYYYY(
          new Date(values?.dob)
        ));
    }

    if (html.getElementById("mediclaim_age") !== null) {
      values?.age &&
        (html.getElementById("mediclaim_age").innerText = values?.age);
    }

    if (html.getElementById("mediclaim_name_last") !== null) {
      values?.name &&
        (html.getElementById("mediclaim_name_last").innerText = capitalizeEachWord(values?.name));
    }

    if (values?.sex === "male") {
      if (html.getElementById("mediclaim_sex_male") !== null) {
        html.getElementById("mediclaim_sex_male").style.display =
          "inline-block";
      }
    }

    if (values?.sex === "female") {
      if (html.getElementById("mediclaim_sex_female") !== null) {
        html.getElementById("mediclaim_sex_female").style.display =
          "inline-block";
      }
    }

    if (html.getElementById("mediclaim_point_12_yes_no") !== null) {
      values?.mediclaim_history_yes_no &&
        (html.getElementById("mediclaim_point_12_yes_no").innerText =
          values?.mediclaim_history_yes_no);
    }

    if (values?.mediclaim_history_yes_no === "yes") {
      if (
        html.getElementById("mediclaim_point_12_are_you_in_good_health") !==
        null
      ) {
        values?.mediclaim_history &&
          (html.getElementById(
            "mediclaim_point_12_are_you_in_good_health"
          ).innerText = values?.mediclaim_history?.are_you_in_good_health);
      }
    } else {
      if (
        html.getElementById("mediclaim_point_12_not_in_good_health") !== null
      ) {
        values?.mediclaim_history &&
          (html.getElementById(
            "mediclaim_point_12_not_in_good_health"
          ).innerText = values?.mediclaim_history?.not_in_good_health);
      }
    }

    if (html.getElementById("mediclaim_point_13_yes_no") !== null) {
      values?.disease_yes_no &&
        (html.getElementById("mediclaim_point_13_yes_no").innerText =
          values?.disease_yes_no);
    }

    if (values?.disease_yes_no === "yes") {
      if (html.getElementById("mediclaim_nervous_mental") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_nervous_mental").innerText =
            values?.disease_history?.nervous_mental);
      }
      if (html.getElementById("mediclaim_spinal_disorder") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_spinal_disorder").innerText =
            values?.disease_history?.spinal_disorder);
      }
      if (html.getElementById("mediclaim_blood_pressure") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_blood_pressure").innerText =
            values?.disease_history?.blood_pressure);
      }
      if (html.getElementById("mediclaim_rheumatic_fever") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_rheumatic_fever").innerText =
            values?.disease_history?.rheumatic_fever);
      }
      if (html.getElementById("mediclaim_piles_hernia") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_piles_hernia").innerText =
            values?.disease_history?.piles_hernia);
      }

      if (html.getElementById("mediclaim_bones_joints") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_bones_joints").innerText =
            values?.disease_history?.bones_joints);
      }

      if (html.getElementById("mediclaim_respiratory_allergic") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_respiratory_allergic").innerText =
            values?.disease_history?.respiratory_allergic);
      }

      if (html.getElementById("mediclaim_stomach_bladder_kidney") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_stomach_bladder_kidney").innerText =
            values?.disease_history?.stomach_bladder_kidney);
      }

      if (html.getElementById("mediclaim_cancer_wound") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_cancer_wound").innerText =
            values?.disease_history?.cancer_wound);
      }

      if (
        html.getElementById("mediclaim_surgical_hospital_treatment") !== null
      ) {
        values?.disease_history &&
          (html.getElementById(
            "mediclaim_surgical_hospital_treatment"
          ).innerText = values?.disease_history?.surgical_hospital_treatment);
      }

      if (
        html.getElementById("mediclaim_surgical_treatment_in_the_future") !==
        null
      ) {
        values?.disease_history &&
          (html.getElementById(
            "mediclaim_surgical_treatment_in_the_future"
          ).innerText =
            values?.disease_history?.surgical_treatment_in_the_future);
      }
      if (html.getElementById("mediclaim_dimness_of_vision") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_dimness_of_vision").innerText =
            values?.disease_history?.dimness_of_vision);
      }

      if (html.getElementById("mediclaim_disease_of_ears") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_disease_of_ears").innerText =
            values?.disease_history?.disease_of_ears);
      }

      if (html.getElementById("mediclaim_urinary_disease") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_urinary_disease").innerText =
            values?.disease_history?.urinary_disease);
      }

      if (html.getElementById("mediclaim_illness_disease_accident") !== null) {
        values?.disease_history &&
          (html.getElementById("mediclaim_illness_disease_accident").innerText =
            values?.disease_history?.illness_disease_accident);
      }
    }

    if (html.getElementById("mediclaim_point_14_yes_no") !== null) {
      values?.dental_yes_no &&
        (html.getElementById("mediclaim_point_14_yes_no").innerText =
          values?.dental_yes_no);
    }

    if (values?.dental_yes_no === "yes") {
      if (html.getElementById("mediclaim_last_treatment") !== null) {
        values?.dental_history &&
          (html.getElementById("mediclaim_last_treatment").innerText =
            values?.dental_history?.last_treatment);
      }
      if (html.getElementById("mediclaim_specify_name") !== null) {
        values?.dental_history &&
          (html.getElementById("mediclaim_specify_name").innerText =
            values?.dental_history?.specify_name);
      }
    }

    if (values?.insurer_yes_no === "yes") {
      if (html.getElementById("mediclaim_insurerAndPolicyNumber") !== null) {
        values?.insurer_history &&
          (html.getElementById("mediclaim_insurerAndPolicyNumber").innerText =
            values?.insurer_history?.insurerAndPolicyNumber);
      }
      if (html.getElementById("mediclaim_period_form") !== null) {
        values?.insurer_history &&
          (html.getElementById("mediclaim_period_form").innerText =
            formatDDMMYYYY(new Date(values?.insurer_history?.period_form)));
      }

      if (html.getElementById("mediclaim_period_to") !== null) {
        values?.insurer_history &&
          (html.getElementById("mediclaim_period_to").innerText =
            formatDDMMYYYY(new Date(values?.insurer_history?.period_to)));
      }

      if (html.getElementById("mediclaim_claim_amount") !== null) {
        values?.insurer_history &&
          (html.getElementById("mediclaim_claim_amount").innerText =
            values?.insurer_history?.claim_amount);
      }
    }

    if (values?.table_illness_accident_yes_no === "yes") {
      if (html.getElementById("nominee_Mediclaim") !== null) {
        console.log(
          "object",
          html.getElementById("nominee_Mediclaim").rows,
          values
        );
        if (values?.nominees) {
          if (html.getElementById("nominee_Mediclaim").rows.length > 1) {
            html.getElementById("nominee_Mediclaim").deleteRow(1);
          }
          for (let i = 0; i < values?.nominees.length; i++) {
            const tr = document.createElement("tr");
            const td = document.createElement("td");
            const span = document.createElement("span");
            span.style.textAlign = "center";
            span.style.display = "block";
            td.style.height = "40px";
            span.innerText = i + 1;
            td.appendChild(span);
            tr.appendChild(td);

            const td1 = document.createElement("td");
            const span1 = document.createElement("span");
            span1.style.textAlign = "center";
            span1.style.display = "block";
            td1.style.height = "40px";
            span1.innerText = values?.nominees[i].nature_of_all;
            td1.appendChild(span1);
            tr.appendChild(td1);

            const td2 = document.createElement("td");
            const span2 = document.createElement("span");
            span2.style.textAlign = "center";
            span2.style.display = "block";
            td2.style.height = "40px";
            span2.innerText = formatDDMMYYYY(
              new Date(values?.nominees[i].date_of_treatment)
            );
            td2.appendChild(span2);
            tr.appendChild(td2);

            const td3 = document.createElement("td");
            const span3 = document.createElement("span");
            span3.style.textAlign = "center";
            span3.style.display = "block";
            td3.style.height = "40px";
            span3.innerText = values?.nominees[
              i
            ]?.name_address_tel_practitioner_disease
              ?.replace(/\n/g, " ")
              ?.trim();
            td3.appendChild(span3);
            tr.appendChild(td3);

            const td4 = document.createElement("td");
            const span4 = document.createElement("span");
            span4.style.textAlign = "center";
            span4.style.display = "block";
            td4.style.height = "40px";
            span4.innerText = values?.nominees[i].fully_cured;
            td4.appendChild(span4);
            tr.appendChild(td4);

            html.getElementById("nominee_Mediclaim").appendChild(tr);
          }
        }
      }
    }

    return html;
  };

  return { filledData };
};

export default useLegalPrifilledData;
